export default function TicheteSocialePage() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <main className="max-w-7xl mx-auto px-4 py-8">

        {/* TITLU */}
        <div className="text-center">
          <h1 className="text-xl font-bold">
            Liceul Tehnologic „Dr. Florian Ulmeanu” Ulmeni
          </h1>
          <h1 className="text-xl font-semibold mt-2">
            ANUNȚ
          </h1>
          <h2 className="text-lg font-semibold">
             privind acordarea tichetelor sociale pe suport electronic pentru sprijin educațional
          </h2>
          <p className="text-m font-semibold mb-2">
            Anul școlar 2025–2026
          </p>
        </div>

        {/* CONTINUT */}
        <div className="bg-white p-6 rounded shadow space-y-4 text-justify text-sm leading-relaxed">

          <p>
            <b>Vă rugăm să informați părinții/reprezentanții legali ai elevilor potențial eligibili.</b> că, 
            în conformitate cu prevederile O.U.G. nr. 83/2023 și ale Legii nr. 248/2015 (republicată), 
            în anul școlar 2025–2026 se acordă tichete sociale pe suport electronic în valoare de 
            500 lei/copil, într-o tranșă unică anuală, pentru sprijin educațional destinat:
          </p>
          <p>
            Conform prevederilor Ordonanței de urgență, în anul școlar 2025-2026 pentru tichetele sociale 
            pe suport electronic sunt eligibilii:
          </p>

          <ol className="pl-5 space-y-2">
            <li>
              <span className="font-bold underline">a) preșcolarii înscriși în învățământul de stat</span>
              <ul className="list-disc pl-6 mt-1 space-y-1">
                <li>
                  copiii dezavantajaţi din învăţământul de stat preşcolar înscrişi în învăţământul 
                  de stat care îndeplinesc condiţiile, în luna iulie a fiecărui an, pentru obţinerea 
                  sprijinului educaţional acordat copiilor din familii defavorizate conform <span className="text-blue-600"> Legii nr. 248/2015</span>, 
                  republicată
                </li>
                <li>
                  Au vârsta minimă de 3 ani, împlinită oricând pe parcursul anului școlar curent, dar devin eligibili 
                  în luna în care împlinesc vârsta de 3 ani;
                </li>
                <li>
                  Au vârsta maximă de 6 ani, împliniți după data de 1 septembrie a anului școlar curent;
                </li>
              </ul>
            </li>
            <li>
              <span className="font-bold underline">b) elevii din învățământul de stat primar și gimnazial,</span>
              <ul className="list-disc pl-6 mt-1 space-y-1">
                <li>
                  copiii dezavantajaţi din învăţământul de stat primar înscrişi în învăţământul de stat primar 
                  care întrunesc criteriile de venit stabilite în Programul naţional de rechizite şcolare, 
                  conform <span className="text-blue-600"> Ordonanţei Guvernului nr. 33/2001</span>, aprobată cu modificări şi completări prin 
                  <span className="text-blue-600"> Legea nr. 126/2002</span>, respectiv care sunt în întreţinerea familiilor al căror venit mediu net 
                  lunar pe membru de familie, realizat în luna iulie a fiecărui an, este de maximum 50% din 
                  salariul de bază minim brut pe ţară; 
                </li>
                <li>
                  copiii dezavantajaţi din învăţământul de stat gimnazial înscrişi în învăţământul de stat 
                  gimnazial, care întrunesc criteriile de venit stabilite în Programul naţional de rechizite 
                  şcolare, conform <span className="text-blue-600"> Ordonanţei Guvernului nr. 33/2001</span>, aprobată cu modificări şi completări prin 
                  <span className="text-blue-600"> Legea nr. 126/2002</span>, respectiv care sunt în întreţinerea familiilor al căror venit mediu net 
                  lunar pe membru de familie,
                   <ul className="list-disc pl-6 mt-1 space-y-1">
                      <li>
                        Cereriile să fie completate cu toate informațiile cerute, datată și semnată;
                      </li>
                      <li>
                        Cererile vor fi preluate de către domni/doamnele educatoare / învățători și diriginți 
                        și vor fi  depuse  la secretariatul unității de învățământ până cel târziu la data de: 
                        <b> 2 octombrie  2025</b>.
                      </li>
                   </ul>
                </li>
              </ul>
            </li>
          </ol>

          <p>
             Vă atașăm și Cererea  pentru acordarea sprijinului educaţional sub formă 
             de tichet social pe suport electronic pentru preşcolarii şi elevii dezavantajaţi 
             din învăţământul de stat preşcolar, primar şi gimnazial.
          </p>

        </div>

        {/* PDF */}
        <div className="flex justify-center">
          <iframe
            src="/educatie/ticheteSociale/Tichete%20sociale.pdf"
            title="Tichete social"
            className="w-full h-[90vh] border rounded"
          ></iframe>
        </div>

      </main>
    </div>
  );
}